var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Button, GBTypography } from '@leapfinance/geebee-component-library';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import RaiseApplicationIcon from '../../geebee/icons/course-details-page/RaiseApplication';
import ShareIcon from '../../geebee/icons/course-details-page/ShareIcon';
import ShortlistIcon from '../../geebee/icons/course-details-page/ShortlistIcon';
import SectionHeader from './SectionHeader';
import { COMPONENT_ID_ENUM } from './types';
var LikedCard = function (_a) {
    var title = _a.title, imageContainerClasses = _a.imageContainerClasses, Logo = _a.Logo, ctaText = _a.ctaText, ctaStartIcon = _a.ctaStartIcon, ctaAction = _a.ctaAction, ctaEndIcon = _a.ctaEndIcon, source = _a.source;
    return (React.createElement("div", { className: "lfc-px-4 lfc-py-3 lfc-rounded-lg lfc-border lfc-border-gbTokens-grey-A400 lfc-flex lfc-items-start lfc-gap-x-3 lfc-col-span-12 lg:lfc-col-span-6 ".concat(source === 'CSP' ? 'xl:lfc-col-span-4' : '') },
        Logo ? (React.createElement("div", { className: "lfc-border lfc-rounded-lg lfc-flex lfc-items-center lfc-justify-center ".concat(imageContainerClasses) },
            React.createElement(Logo, null))) : null,
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-3 lfc-justify-between lfc-h-full" },
            React.createElement(GBTypography, { variant: "sh3Semibold", className: "lfc-text-grey-900" }, title),
            React.createElement(Button, { startIcon: ctaStartIcon !== null && ctaStartIcon !== void 0 ? ctaStartIcon : null, endIcon: ctaEndIcon !== null && ctaEndIcon !== void 0 ? ctaEndIcon : null, onClick: ctaAction, size: "small", className: "lfc-whitespace-nowrap" }, ctaText))));
};
var LikedCourseSection = function (_a) {
    var handleAddToApplication = _a.handleAddToApplication, handleAddToShortlist = _a.handleAddToShortlist, handleDownloadCoursePdf = _a.handleDownloadCoursePdf, source = _a.source;
    var likedSections = [
        {
            title: 'Want to shortlist this course for student?',
            ctaText: 'Add to Shortlist',
            ctaStartIcon: React.createElement(AddRoundedIcon, null),
            Logo: ShortlistIcon,
            imageContainerClasses: 'lfc-bg-gbTokens-teal-100 lfc-border-gbTokens-teal-300',
            ctaAction: handleAddToShortlist
        },
        {
            title: 'Want to share this course for student?',
            ctaText: 'Download PDF',
            ctaStartIcon: React.createElement(SaveAltRoundedIcon, null),
            Logo: ShareIcon,
            imageContainerClasses: 'lfc-bg-gbTokens-sapphire-100 lfc-border-gbTokens-sapphire-300',
            ctaAction: handleDownloadCoursePdf
        },
        source === 'CSP' && {
            title: 'Want to raise any application for student?',
            ctaText: 'Raise Application',
            ctaEndIcon: React.createElement(ArrowForwardRoundedIcon, null),
            Logo: RaiseApplicationIcon,
            imageContainerClasses: 'lfc-bg-gbTokens-cloud-100 lfc-border-gbTokens-sapphire-400',
            ctaAction: handleAddToApplication
        }
    ];
    return (React.createElement("div", { className: "lfc-bg-white lfc-p-3 lg:lfc-p-4 lfc-rounded-lg", id: COMPONENT_ID_ENUM.COURSE_LIKED_SECTION },
        React.createElement(SectionHeader, { title: "Liked this Course?" }),
        React.createElement("div", { className: "lfc-w-full lfc-grid lfc-grid-cols-12 lfc-gap-4" }, likedSections === null || likedSections === void 0 ? void 0 : likedSections.map(function (section) {
            if (!section)
                return null;
            return React.createElement(LikedCard, __assign({ key: section === null || section === void 0 ? void 0 : section.title }, section, { source: source }));
        }))));
};
export default LikedCourseSection;
//# sourceMappingURL=LikedCourseSection.js.map